import { FC } from "preact/compat";
import DonutIcon from "~/assets/donut.svg";

const Preview: FC = () => (
    <div className="size-full flex items-center justify-center">
        <DonutIcon width="60" height="60" />
    </div>
);

export default Preview;
